export default __webpack_public_path__ + "static/media/foot-left-front.54b34b74.png";